import React, { useState } from "react";
import DataTable from "../homepage_reusable_components/DataTable";
import SalesPieChart from "../homepage_reusable_components/SalesPieChart";
import SalesBarChart from "../homepage_reusable_components/SalesBarChart";
import ChartContainer from "../homepage_reusable_components/ChartContainer";
import ChurnChart from "../homepage_reusable_components/ChurnChart";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ShowChartIcon from "@mui/icons-material/ShowChart"; // or LineStyleIcon

import { Button, ButtonGroup } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import TableChartIcon from "@mui/icons-material/TableChart";
import CircularProgressbar from "../homepage_reusable_components/CircularProgressbar";
import CircularProgressbarChart from "../homepage_reusable_components/CircularProgressbar";
import SalesBarChart2 from "../homepage_reusable_components/SalesBarChart2";
import SalesBarChart3 from "../homepage_reusable_components/SalesBarChart3";
import SalesLineChart from "../homepage_reusable_components/SalesLineChart";
import SalesLineChart2 from "../homepage_reusable_components/SalesLineChart2";
import GroupedBarChart from "../homepage_reusable_components/GroupedBarChart";
import ProfileHeatMap from "../homepage_reusable_components/FinancialPerformanceChart";
import MonthlySalesTrendChart from "../homepage_reusable_components/MonthlySalesTrendChart";
import AttendanceBubbleChart from "../homepage_reusable_components/AttendanceBubbleChart";
import LeaveSummary from "../homepage_reusable_components/LeaveSummary";
import SixMonthSalesComparison from "../homepage_reusable_components/SixMonthSalesComparison";
import ic_sales_panel from "../utils/ic_sales_panel.png"
import ic_crm_panel from "../utils/ic_crm_panel.png"
import ic_arrow_end from "../utils/ic_arrow_end.png"
import ic_customer_analytics_panel from "../utils/ic_customer_analytics_panel.png"
import ic_cash_flow_panel from "../utils/ic_cash_flow_panel.png"
import ic_stock_panel from "../utils/ic_stock_panel.png"
import DataTableSwitchCase from "../homepage_reusable_components/DataTableSwitchCase";
import TodaysBranchSales from "../homepage_reusable_components/TodaysBranchSales";
import TodaysSalesSalesperson from "../homepage_reusable_components/TodaysSalesSalesperson";
import CustomerHealthSummary from "../homepage_reusable_components/CustomerHealthSummary";
import "../css/Home.css"

const Home = () => {

  const [currentOpenLevelOne, setCurrentOpenLevelOne] = useState(0)
  const [currentOpenLevelTwo, setCurrentOpenLevelTwo] = useState(0)
  const [currentOpenLevelThree, setCurrentOpenLevelThree] = useState(0)
  const [viewChurnMode, setViewChurnMode] = useState("chart");
  const [viewPerformanceMode, setViewPerformanceMode] = useState("chart");
  const [viewCustomerAquisitionMode, setViewCustomerAquisitionMode] =
    useState("chart");
  const [salesForeCastMode, setSalesForeCastMode] = useState("chart");
  const [viewCustomerHealthMode, setViewCustomerHealthMode] = useState("chart");
  const [viewSalesMode, setViewSalesMode] = useState("chart");
  const [viewAcquisitionMode, setViewAcquisitionMode] = useState("chart");
  const [salesPerformanceMode, setSalesPerformanceMode] = useState("chart");
  const [salesTrendMode, setSalesTrendMode] = useState("chart");
  const [salesRecieptMode, setSalesRecieptMode] = useState("chart");
  const [profitAnalysisMode, setProfitAnalysisMode] = useState("chart");
  const [profitAnalysisBranchMode, setProfitAnalysisBranchMode] = useState("chart");


  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const homecard_ui_json = [
    {
      category: "Sales & Performance Analysis",
      level: "1",
      icon: ic_sales_panel,
      children: [
        {
          name: "Sales Tracking & Trends",
          level: "2",
          children: [
            {
              name: "Todays Sales Branch Wise",
              level: "3",
              componentName: <div className="my-4 col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <div className="flex justify-between mb-1 sm:mb-2 items-center">
                  <h2 className="text-md sm:text-xl font-medium text-gray-700">
                    Todays Sales Branch
                  </h2>
                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="salesman trend toggle"
                  >
                    <Button
                      color={
                        salesTrendMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesTrendMode("chart")}
                    >
                      {/* <ShowChartIcon /> */}
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        salesTrendMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesTrendMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="sm:h-[200px] ">
                  {salesTrendMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[500px] ">
                      <TodaysBranchSales endpoint="Todays_Sales_Branch" />
                    </div>
                  ) : (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[300px] overflow-auto">
                      <DataTableSwitchCase endpoint="Todays_Sales_Branch" />
                    </div>
                  )}
                </div>
              </div>
            },
            {
              name: "Todays Sales Salesperson Wise",
              level: "3",
              componentName: <div className="my-4 col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <div className="flex justify-between mb-1 sm:mb-2 items-center">
                  <h2 className="text-md sm:text-xl font-medium text-gray-700">
                    Todays Salesperson Wise
                  </h2>
                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="salesman trend toggle"
                  >
                    <Button
                      color={
                        salesTrendMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesTrendMode("chart")}
                    >
                      {/* <ShowChartIcon /> */}
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        salesTrendMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesTrendMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="sm:h-[200px] ">
                  {salesTrendMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[500px] ">
                      <TodaysSalesSalesperson endpoint="Todays_Sales_Branch_Salesperson" />
                    </div>
                  ) : (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[300px] overflow-auto">
                      <DataTableSwitchCase endpoint="Todays_Sales_Branch_Salesperson" />
                    </div>
                  )}
                </div>
              </div>
            },
            {
              name: "6-month comparative sales",
              level: "3",
              componentName: <SixMonthSalesComparison
              />
            },
            {
              name: "Month-on-month sales comparison",
              level: "3",
              componentName: <div className="my-4 col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <div className="flex justify-between mb-1 sm:mb-2 items-center">
                  <h2 className="text-md sm:text-xl font-medium text-gray-700">
                    MONTHLY SALES TREND
                  </h2>
                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="salesman trend toggle"
                  >
                    <Button
                      color={
                        salesTrendMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesTrendMode("chart")}
                    >
                      {/* <ShowChartIcon /> */}
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        salesTrendMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesTrendMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="sm:h-[200px] ">
                  {salesTrendMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[500px] ">
                      <MonthlySalesTrendChart endpoint="MONTH_SALES_COMP" />
                    </div>
                  ) : (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[300px] overflow-auto">
                      <DataTable endpoint="MONTH_SALES_COMP" />
                    </div>
                  )}
                </div>
              </div>
            },
            {
              name: "Sales growth rate over time",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  SALES GROWTH RATE
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="Sales_Growth_Rate" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Sales Targets & Forecasts",
          level: "2",
          children: [
            {
              name: "Target vs actual sales",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                {/* <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">SALES FORECAST</h2> */}
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  SALES TARGET ANALYSIS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  {/* <DataTable endpoint="SALES_FORCAST" /> */}
                  <DataTable endpoint="SALES_TARGET_ANALYSIS" />
                </div>
              </div>
            },
            {
              name: "Sales projections and forecast",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <div className="flex justify-between mb-1 sm:mb-2">
                  <div></div>
                  <h2 className="text-md sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                    SALES FORECAST
                  </h2>

                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="sales forecast toggle"
                  >
                    <Button
                      color={
                        salesForeCastMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesForeCastMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        salesForeCastMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesForeCastMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>

                <div className="sm:h-[calc(100%-2.5rem)] ">
                  {/* <div className="overflow-auto"> */}
                  {salesForeCastMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[400px] ">
                      <SalesBarChart
                        endpoint="SALES_FORECAST"
                        barColor="#14A2B8"
                        yAxisTitle="Forecast Sales"
                      />
                    </div>
                  ) : (
                    // <div className="h-full overflow-auto">
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[300px] overflow-auto ">
                      {/* <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">SALES FORECAST</h2> */}
                      <DataTable endpoint="SALES_FORECAST" />
                    </div>
                  )}
                </div>
              </div>
            }
          ]
        },
        {
          name: "Product & Department Performance",
          level: "2",
          children: [
            {
              name: "Most sold products",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  TOP 50 SELLING PRODUCTS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="Top_50_Selling_Products" />
                </div>
              </div>
            },
            {
              name: "Top 100 ordered products",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  TOP 100 ORDER PRODUCTS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="CRM_TOP100ORDER_PRODUCTS" />
                </div>
              </div>

            },
            {
              name: "Daily department sales",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  DAILYSALES DEPARTMENT
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="DAILYSALES_DEPT" />
                </div>
              </div>
            },
            {
              name: "Monthly department sales",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  MONTHLY SALES DEPARTMENT
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="MONTHLYSALES_DEPT" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Salesperson & Team Performance",
          level: "2",
          children: [
            {
              name: "Monthly salesperson performance",
              level: "3",
              componentName: <div className="my-4 col-span-1 lg:col-span-6 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[600px]">
                <div className="flex justify-between mb-1 sm:mb-2 items-center">
                  <h2 className="text-md sm:text-xl font-medium text-gray-700">
                    SALESMAN MONTH PERFORMANCE
                  </h2>
                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="salesman performance toggle"
                  >
                    <Button
                      color={
                        salesPerformanceMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesPerformanceMode("chart")}
                    >
                      <ShowChartIcon />
                    </Button>
                    <Button
                      color={
                        salesPerformanceMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setSalesPerformanceMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>

                {/* <div className="sm:h-[calc(100%-2.5rem)] overflow-auto"> */}
                <div className="sm:h-[600px] overflow-auto">
                  {salesPerformanceMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[600px] overflow-auto">
                      <SalesLineChart endpoint="SALESMAN_MONTHPERFORMANCE" />
                    </div>
                  ) : (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[600px] overflow-auto">
                      <DataTable endpoint="SALESMAN_MONTHPERFORMANCE" />
                    </div>
                  )}
                </div>
              </div>



            },
            {
              name: "Sales team performance summary",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  SALESMAN PERFORMANCE SUMMARY
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="SAMAN_PERF_SUMM" />
                </div>
              </div>
            }
          ]
        }
      ]
    },
    {
      category: "CRM Intelligence & Relationship Management",
      level: "1",
      icon: ic_crm_panel,
      children: [
        {
          name: "Lead Funnel & Conversion",
          level: "2",
          children: [
            {
              name: "Opportunity funnel view",
              level: "3",
              componentName: <div style={{ overflowY: "scroll" }} className="mb-4 sm:mb-0 mt-6 col-span-1 lg:col-span-2 bg-white shadow-md  rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <ChartContainer />
              </div>
            },
            {
              name: "Monthly lead/deal tracking",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  MONTHLY LEAD PIPELINE
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="MONTH_LEAD_PIPELINE" />
                </div>
              </div>
            },
            {
              name: "Lead-to-customer conversion rate",
              level: "3",
              componentName: <div className=" my-4 sm:my-0 col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg flex items-center justify-right p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <SalesPieChart />
              </div>
            }
          ]
        },
        {
          name: "CRM Staff Performance",
          level: "2",
          children: [
            {
              name: "Salesperson performance (CRM-specific)",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <div className="flex justify-between mb-1 sm:mb-2">
                  <div></div>
                  <h2 className="text-md sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                    SALESMAN PERFORMANCE
                  </h2>

                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="Sales toggle"
                  >
                    <Button
                      color={
                        viewPerformanceMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setViewPerformanceMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        viewPerformanceMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setViewPerformanceMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className=" sm:h-[calc(100%-2.5rem)] ">
                  {viewPerformanceMode === "chart" ? (
                    // <div className="h-full overflow-auto">
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[400px] ">
                      <SalesBarChart
                        endpoint="CRM_SALESMAN_PERFORM"
                        barColor="#FDB411"
                        yAxisTitle="Total Orders"
                      />
                    </div>
                  ) : (
                    // <div className="h-full overflow-auto">
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[300px] overflow-auto ">
                      {/* <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">SALESMAN PERFORMANCE</h2> */}
                      <DataTable endpoint="CRM_SALESMAN_PERFORM" />
                    </div>
                  )}
                </div>
              </div>
            },
            {
              name: "Coordinator performance",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <SalesBarChart
                  endpoint="CRM_COORDINATOR_PERFORM"
                  barChartTitle="COORDINATOR PERFORMANCE"
                  barColor="#00C7F1"
                  yAxisTitle="Total Orders"
                />
              </div>
            }
          ]
        }
      ]
    },
    {
      category: "Customer Analytics & Relationship Insights",
      level: "1",
      icon: ic_customer_analytics_panel,
      children: [
        {
          name: "Customer Acquisition & Growth",
          level: "2",
          children: [
            {
              name: "New customer registration trends",
              level: "3",
              componentName: <SalesBarChart2
                endpoint="New_Client_Acquisition_6mon"
                barChartTitle="NEW CLIENT ACQUISITION (Current)"
                barColor="#FF7FC5"
                // yAxisTitle="Clients / Revenue"
                yAxisTitle="New Clients (Current 6 Months)"
              />
            },
            {
              name: "Last 6 months acquisition",
              level: "3",
              componentName: <SalesBarChart3
                endpoint="New_Client_Acquisition_6mon"
                barChartTitle="NEW CLIENT ACQUISITION (Previous)"
                barColor="#FB923C"
                // yAxisTitle="Clients / Revenue"
                yAxisTitle="New Clients (Previous 6 Months)"
              />
            }
          ]
        },
        {
          name: "Retention, Churn & Health",
          level: "2",
          children: [
            {
              name: "Returning/loyal customer analysis",
              level: "3",
              componentName: <div className="my-4 sm:my-0  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  CUSTOMER RETENTION
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="CRM_CUSTOMER_RETENSION" />
                </div>
              </div>
            },
            {
              name: "Lost/inactive customer tracking",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 sm:col-span-3 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                {/* Toggle Button Group */}
                <div className="flex justify-between items-center mb-1">
                  <div></div>
                  <h2 className="text-lg md:text-xl font-normal text-center mb-2">
                    CHURN CHART
                  </h2>

                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="View toggle"
                  >
                    <Button
                      color={viewChurnMode === "chart" ? "primary" : "inherit"}
                      onClick={() => setViewChurnMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={viewChurnMode === "table" ? "primary" : "inherit"}
                      onClick={() => setViewChurnMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>

                {/* Content Area */}
                <div className="h-[calc(100%-1rem)]  md:w-full overflow-auto">
                  {viewChurnMode === "chart" ? (
                    <div className="">
                      <ChurnChart />
                    </div>
                  ) : (
                    <div className="h-full overflow-auto">
                      {/* <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">CHURN ANALYSIS</h2> */}
                      <DataTable endpoint="CRM_CHURN_ANALYSIS" />
                    </div>
                  )}
                </div>
              </div>
            },
            {
              name: "Engagement score and summary",
              level: "3",
              componentName: <div className="relative bg-white shadow-md rounded-lg p-2 sm:p-4 sm:h-[400px] w-[300px] sm:w-auto   col-span-4 sm:col-span-4  overflow-hidden">
                <div className="flex justify-between mb-1 sm:mb-2">
                  <div></div>
                  <h2 className="text-sm sm:text-xl font-medium mb-1 sm:mb-3 text-gray-700">
                    CUSTOMER HEALTH SUMMARY
                  </h2>
                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="View toggle"
                  >
                    <Button
                      color={
                        viewCustomerHealthMode === "chart" ? "primary" : "inherit"
                      }
                      onClick={() => setViewCustomerHealthMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        viewCustomerHealthMode === "table" ? "primary" : "inherit"
                      }
                      onClick={() => setViewCustomerHealthMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                {/* <h2 className="text-md sm:text-xl font-medium mb-1 sm:mb-3 text-gray-700">CUSTOMER HEALTH SUMMARY</h2> */}
                {viewCustomerHealthMode === "table" ? (
                  <div className="h-full overflow-auto">
                    <DataTable endpoint="Customer_Health_Summary" />
                  </div>
                ) : (
                  <div className="h-full grid  grid-cols-1 sm:grid-cols-1 flex items-center justify-center">
                    {/* <CircularProgressbarChart
                      endPoint="Customer_Health_Summary"
                      percentage={66}
                    /> */}
                    <CustomerHealthSummary />
                  </div>
                )}
              </div>
            }
          ]
        },
        {
          name: "Customer Value & Performance",
          level: "2",
          children: [
            {
              name: "Lifetime customer value",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  CUSTOMER LIFETIME VALUE
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="CRM_CUST_LIFETIME_VALUE" />
                </div>
              </div>
            },
            {
              name: "6-month key customer performance",
              level: "3",
              componentName: <div className="my-4 sm:my-4 col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  CUSTOMER PERFORMANCE (6 MONTHS)
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="CUST_PERF_6MONTH" />
                </div>
              </div>
            }
          ]
        }
      ]
    },
    {
      category: "Financial Intelligence & Cash Flow",
      level: "1",
      icon: ic_cash_flow_panel,
      children: [
        {
          name: "Profitability Analysis",
          level: "2",
          children: [
            {
              name: "Company-wide profit summary",
              level: "3",
              componentName: <div className="bg-white my-4 sm:my-4  col-span-1 sm:col-span-2  shadow-md rounded-lg p-2 sm:py-2 sm:px-6 h-[500px] w-[300px] sm:w-auto sm:h-[500px] ">

                <div className="flex justify-between mb-1 sm:mb-2 ">
                  {/* <div></div> */}
                  <h2 className="text-md sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                    PROFIT ANALYSIS COMPANY
                  </h2>


                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="PROFIT ANALYSIS COMPANY toggle"
                  >
                    <Button
                      color={
                        profitAnalysisMode === "chart"
                          ? "primary"
                          : "inherit"
                      }
                      onClick={() => setProfitAnalysisMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        profitAnalysisMode === "table"
                          ? "primary"
                          : "inherit"
                      }
                      onClick={() => setProfitAnalysisMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="sm:h-[800px] overflow-auto ">
                  {profitAnalysisMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[600px] overflow-auto ">
                      <GroupedBarChart endpoint="Profit_Analysis_Company" />
                    </div>
                  ) : (
                    <div className="h-[200px] sm:h-[300px] overflow-auto">
                      <DataTable endpoint="Profit_Analysis_Company" />
                    </div>
                  )}
                </div>
              </div>
            },
            {
              name: "Branch-level profitability",
              level: "3",
              componentName: <div className="bg-white my-4 sm:my-4  col-span-1 sm:col-span-2  shadow-md rounded-lg p-2 sm:py-2 sm:px-6 h-[500px] w-[300px] sm:w-auto sm:h-[500px] ">

                <div className="flex justify-between mb-1 sm:mb-2 ">
                  {/* <div></div> */}
                  <h2 className="text-md sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                    PROFIT ANALYSIS BRANCH
                  </h2>


                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="PROFIT ANALYSIS Branch toggle"
                  >
                    <Button
                      color={
                        profitAnalysisBranchMode === "chart"
                          ? "primary"
                          : "inherit"
                      }
                      onClick={() => setProfitAnalysisBranchMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        profitAnalysisBranchMode === "table"
                          ? "primary"
                          : "inherit"
                      }
                      onClick={() => setProfitAnalysisBranchMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="sm:h-[800px] overflow-auto ">
                  {profitAnalysisBranchMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[600px] overflow-auto ">
                      <ProfileHeatMap endpoint="Profit_Analysis_Branch" />
                    </div>
                  ) : (
                    <div className="h-[200px] sm:h-[300px] overflow-auto">
                      <DataTable endpoint="Profit_Analysis_Branch" />
                    </div>
                  )}
                </div>
              </div>
            }
          ]
        },
        {
          name: "Cash Flow & Fund Position",
          level: "2",
          children: [
            {
              name: "Overall cash inflow/outflow",
              level: "3",
              componentName: <div className="mt-4 mb-8 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  CASH FLOW
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto mb-16">
                  <DataTable endpoint="CASHFLOW" />
                </div>
              </div>
            },
            {
              name: "Bank and cash balances",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  CASH AND BANK POSITION
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="Cash_And_Bank_Position" />
                </div>
              </div>
            },
            {
              name: "Cash forecast for 30 days",
              level: "3",
              componentName: <div className="mt-4 mb-8 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  CASH FUND FORCAST 30 DAYS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto mb-16">
                  <DataTable endpoint="CASH_FUND_FORCAST_30DAYS" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Receivables & Collections",
          level: "2",
          children: [
            {
              name: "Outstanding receivables aging",
              level: "3",
              componentName: <div className="mt-4 mb-8 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  RECIEVABLE AGEING ANALYSIS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto mb-16">
                  <DataTable endpoint="AGEINGREPORT" />
                </div>
              </div>

            },
            {
              name: "Daily sales vs receipts",
              level: "3",
              componentName: <div className="mt-4 mb-8 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  LAST 30 DAYS SALES VS RECIEPTS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto mb-16">
                  <DataTable endpoint="Last_30Days_Sales_vs_Receipts" />
                </div>
              </div>
            },
            {
              name: "Monthly reconciliation",
              level: "3",
              componentName: <div className="bg-white my-4 sm:my-4  col-span-1 sm:col-span-2  shadow-md rounded-lg p-2 sm:py-2 sm:px-6 h-[500px] w-[300px] sm:w-auto sm:h-[500px] ">

                <div className="flex justify-between mb-1 sm:mb-2 ">
                  {/* <div></div> */}
                  <h2 className="text-md sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                    SALES VS RECIEPT MONTHLY
                  </h2>

                  <ButtonGroup
                    disableElevation
                    variant="contained"
                    aria-label="Sales Reciept toggle"
                  >
                    <Button
                      color={
                        salesRecieptMode === "chart"
                          ? "primary"
                          : "inherit"
                      }
                      onClick={() => setSalesRecieptMode("chart")}
                    >
                      <BarChartIcon />
                    </Button>
                    <Button
                      color={
                        salesRecieptMode === "table"
                          ? "primary"
                          : "inherit"
                      }
                      onClick={() => setSalesRecieptMode("table")}
                    >
                      <TableChartIcon />
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="sm:h-[800px] overflow-auto ">
                  {salesRecieptMode === "chart" ? (
                    <div className="h-[500px] w-[300px] sm:w-auto sm:h-[600px] overflow-auto ">
                      {/* <SalesLineChart endpoint="SALESMAN_MONTHPERFORMANCE" /> */}
                      <SalesLineChart2 endpoint="SalesVsReceipt_Monthly" />
                    </div>
                  ) : (
                    <div className="h-[200px] sm:h-[300px] overflow-auto">
                      <DataTable endpoint="SalesVsReceipt_Monthly" />
                    </div>
                  )}
                </div>
              </div>
            }
          ]
        },
        {
          name: "Cost & Expense Analysis",
          level: "2",
          children: [
            {
              name: "Expense trend tracking",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  MONTHLY EXPENSE ANALYSIS
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTable endpoint="Monthly_Expense_analysis" />
                </div>
              </div>
            }
          ]
        }
      ]
    },
    {
      category: "Inventory Intelligence & Stock Performance",
      level: "1",
      icon: ic_stock_panel,
      children: [
        {
          name: "Stock Position & Movement",
          level: "2",
          children: [
            {
              name: "Real-time quantity and value of all inventory items",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Current Stock Position
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Current_Stock_Position" />
                </div>
              </div>
            },
            {
              name: "Warehouse-wise or branch-wise stock snapshot",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Current Stock Position
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Stock_By_Location" />
                </div>
              </div>

            },
            {
              name: "Items with highest turnover/sales rate",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Fast Moving Items
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Fast_Moving_Items_90Days_Top50" />
                </div>
              </div>
            },
            {
              name: "Items with low or stagnant movement",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Slow Moving Items
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Slow_Moving_Items_90Days" />
                </div>
              </div>

            },
            {
              name: "Items with no movement for 3/6/12+ months",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Non Moving Items
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Non_Moving_Items_90Days" />
                </div>
              </div>

            },
            {
              name: "Items showing below-zero stock (possible errors)",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Negative Stock Report
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Negative_Stock_Report" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Inventory Valuation & Cost Analysis",
          level: "2",
          children: [
            {
              name: "Inventory_Valuation_Report",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Inventory Valuation Report
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Inventory_Valuation_Report" />
                </div>
              </div>
            },
            {
              name: "Stock_Aging_Report",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Stock Aging Report
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Stock_Aging_Report" />
                </div>
              </div>
            },
            {
              name: "Inventory_Cost_Summary",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Inventory Cost Summary
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Inventory_Cost_Summary" />
                </div>
              </div>
            },
            {
              name: "Overstock_Analysis",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Overstock Analysis
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Overstock_Analysis" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Replenishment & Demand Forecasting",
          level: "2",
          children: [
            {
              name: "Reorder Level Report",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Reorder_Level_Report
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Reorder_Level_Report" />
                </div>
              </div>
            },
            {
              name: "Stock Reorder Suggestions",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Stock Reorder Suggestions
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Stock_Reorder_Suggestions" />
                </div>
              </div>
            },
            {
              name: "Seasonal_Demand_Patterns",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Seasonal Demand Patterns
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Seasonal_Demand_Patterns" />
                </div>
              </div>

            },
            {
              name: "Forecasted_Inventory_Needs",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Forecasted Inventory Needs
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Forecasted_Inventory_Needs" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Inventory Efficiency KPIs",
          level: "2",
          children: [
            {
              name: "Inventory_Turnover_Ratio",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Inventory Turnover Ratio
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Inventory_Turnover_Ratio" />
                </div>
              </div>
            },
            {
              name: "Days_Sales_Of_Inventory (DSI)",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Days Sales Of Inventory
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Days_Sales_Of_Inventory" />
                </div>
              </div>
            },
            {
              name: "Dead_Stock_Percentage",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Dead Stock Percentage
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Dead_Stock_Percentage" />
                </div>
              </div>
            },
            {
              name: "Stock_Health_Index",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Stock Health Index
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Stock_Health_Index" />
                </div>
              </div>
            }
          ]
        },
        {
          name: "Profitability & Margin Impact",
          level: "2",
          children: [
            {
              name: "Stock_Margin_Analysis",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Stock_Margin Analysis
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Stock_Margin_Analysis" />
                </div>
              </div>
            },
            {
              name: "High_Value_Stock_Watchlist",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  High Value Stock Watchlist
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="High_Value_Stock_Watchlist" />
                </div>
              </div>
            },
            {
              name: "Inventory_vs_Sales_Trend",
              level: "3",
              componentName: <div className="my-4 sm:my-4  col-span-1 lg:col-span-2 bg-white shadow-md rounded-lg p-2 sm:p-4 h-[500px] w-[300px] sm:w-auto sm:h-[400px]">
                <h2 className="text-lg sm:text-xl font-medium mb-1 sm:mb-2 text-gray-700">
                  Inventory vs Sales Trend
                </h2>
                <div className="h-[200px] sm:h-[300px] overflow-auto">
                  <DataTableSwitchCase endpoint="Inventory_vs_Sales_Trend" />
                </div>
              </div>

            }
          ]
        }
      ]
    }
  ]

  const toggleLevelOne = (index) => {

    console.log("index", index)

    if (index == currentOpenLevelOne) {
      setCurrentOpenLevelOne(-1)
    } else {
      setCurrentOpenLevelOne(index)
    }



  }

  const toggleLevelTwo = (index) => {

    console.log("index toggleLevelTwo currentOpenLevelTwo", index, currentOpenLevelTwo)

    if (index == currentOpenLevelTwo) {
      setCurrentOpenLevelTwo(-1)
    } else {
      setCurrentOpenLevelTwo(index)
    }
  }

  const toggleLevelThree = (index) => {

    console.log("index toggleLevelThree currentOpenLevelThree currentOpenLevelOne", index, currentOpenLevelThree, currentOpenLevelOne)

    if (index == currentOpenLevelThree) {
      setCurrentOpenLevelThree(-1)
    } else {
      setCurrentOpenLevelThree(index)
    }


  }

  return (
    <div className="p-2 sm:p-4 space-y-4 sm:space-y-6 home-analytics-container">
      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
        Analytics
      </h2>

      <div className="master_container_menu_home" >
        {
          homecard_ui_json.map((item, index) => {
            return (
              <div className="bg-white border border-gray-200 rounded p-2 main_category_card_item">
                <div className="flex button-91" onClick={() => toggleLevelOne(index)} style={{backgroundColor:"#f7f7f7", padding:"6px" , alignItems:"center"}}>
                 
                  <button style={{ width: "10%", display: "inline-block", fontSize: 20, backgroundColor: "#b2b2b2", borderRadius: "5px" }} >{currentOpenLevelOne == index ? "-" : "+"}</button>
                  <img src={item.icon} style={{
                    width: "45px",
                    height: "45px",
                    objectFit: "contain",
                    padding: "2px",
                    marginLeft:"10px"
                  }} />
                  <h4 style={{
                    width: "90%",
                    fontWeight: "600",
                    color: "#000000",
                    paddingLeft:"10px"
                  }} >{item.category}</h4>
                  
                </div>
                {
                  (currentOpenLevelOne == index || screenSize?.width > 768) &&
                  <div className="m-2" >
                    {
                      item.children.map((item2, index2) => {
                        return (
                          <div className="bg-white border border-gray-200 rounded p-2">
                            <div className="flex button-91" onClick={() => toggleLevelTwo(index2)} style={{backgroundColor:"#f7f7f7", padding:"6px",marginBottom:"6px"}} >
                            <button style={{ width: "10%", display: "inline-block", fontSize: 20, backgroundColor: "#b2b2b2", borderRadius: "5px" }}>{currentOpenLevelTwo == index2 ? "-" : "+"}</button>
                              <h5 style={{
                                color: "#98854a",
                                width: "90%",
                                fontWeight: "700",
                                marginLeft:"10px"
                              }}>{item2.name}</h5>
                              
                            </div>
                            {
                              currentOpenLevelTwo == index2 &&
                              item2.children.map((item3, index3) => {
                                return (
                                  <div>
                                    <div onClick={() => toggleLevelThree(index3)} className="flex button-91" style={{  borderRadius: "15px" ,marginTop:"10px", padding: "8px",alignItems: "center"}}>
                                    {/* <button  style={{ width: "10%", display: "inline-block", fontSize: 20, }}>{currentOpenLevelThree == index3 ? "-" : "+"}</button> */}
                                    <img style={{width:"30px"}} src={ic_arrow_end}/>
                                      <h6 style={{ width: "90%", fontWeight: "300", color: "#000000", marginLeft:"6px", fontWeight:"400" }}>{item3.name}</h6>
                                      
                                    </div>

                                    {
                                      currentOpenLevelThree == index3 &&

                                      item3.componentName &&
                                      item3.componentName

                                    }


                                  </div>
                                )
                              })
                            }
                          </div>
                        )
                      })
                    }
                  </div>
                }

              </div>
            )
          })
        }
      </div>


    </div>
  );
};

export default Home;